module.exports = __webpack_public_path__ + "img/131.3159b5a5.jpg";